export const FRAUD_HISTORY_PAGE_SIZE = 50;

export function buildFraudHistoryQuery(filters = {}, cursor = null, limit = FRAUD_HISTORY_PAGE_SIZE) {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (cursor) params.set("cursor", cursor);
  ["status", "date_from", "date_to", "vehicle_id", "booking_id"].forEach((key) => {
    const value = String(filters[key] || "").trim();
    if (value && !(key === "status" && value === "all")) params.set(key, value);
  });
  return `?${params.toString()}`;
}

export function fraudSubject(row) {
  if (row.vehicle_available === false) return "Deleted vehicle";
  return row.vehicle_label || row.vehicle_id || "Unknown vehicle";
}

